import styled from "styled-components";

/**
 * ログイン画面のスタイルコンポーネント
 * スカンジナビア風・明るめで日本人に親しみやすいデザイン
 */
const LoginStyles = {
  // ========== スカンジナビア・明るいログイン ==========
  BodyBackground: styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background: linear-gradient(180deg, #f5f2ed 0%, #ebe6df 50%, #e8e4dc 100%);
    padding: 2rem 1rem 1.5rem;
    box-sizing: border-box;
  `,

  LoginContainer: styled.div`
    width: 100%;
    max-width: 440px;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  `,

  /** ヘッダーとメインコンテンツをまとめ、中央に寄せつつフッターを下部に押し出すためのラッパー */
  ContentWrapper: styled.div`
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  `,

  Header: styled.header`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  `,

  Logo: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    width: 100%;
    height: 100%;
    img,
    svg {
      max-height: 48px;
      width: auto;
      height: auto;
      display: block;
    }
  `,

  Container: styled.div`
    width: 100%;
  `,

  Main: styled.main`
    width: 100%;
  `,

  LoginBox: styled.div`
    width: 100%;
    background: #fefdfb;
    border-radius: 20px;
    box-shadow:
      0 4px 24px rgba(0, 0, 0, 0.06),
      0 0 0 1px rgba(0, 0, 0, 0.04);
    padding: 2.25rem 2rem;
    box-sizing: border-box;
  `,

  LoginForm: styled.div`
    width: 100%;
  `,

  LoginTitle: styled.p`
    margin: 0 0 1.75rem;
    font-size: 1.5rem;
    font-weight: 600;
    color: #3d3a36;
    letter-spacing: 0.04em;
    text-align: center;
    line-height: 1.4;
  `,

  LoginContent: styled.div`
    margin: 0;
  `,

  LoginTable: styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.25rem;

    .field {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
    .field label {
      font-size: 0.875rem;
      font-weight: 500;
      color: #5c574f;
    }
    .field input {
      width: 100%;
      box-sizing: border-box;
      padding: 0.75rem 1rem;
      font-size: 0.9375rem;
      line-height: 1.5;
      color: #3d3a36;
      background: #faf9f7;
      border: 1px solid #e5e2dd;
      border-radius: 12px;
      outline: none;
      transition:
        border-color 0.2s,
        box-shadow 0.2s;
    }
    .field input::placeholder {
      color: #9c968d;
    }
    .field input:hover {
      border-color: #d4d0c8;
    }
    .field input:focus {
      border-color: #7d8b6f;
      box-shadow: 0 0 0 3px rgba(125, 139, 111, 0.18);
    }
    .field input[type="text"],
    .field input[type="password"] {
      -webkit-appearance: none;
      appearance: none;
    }
    .field input:-webkit-autofill,
    .field input:-webkit-autofill:hover,
    .field input:-webkit-autofill:focus {
      -webkit-box-shadow: 0 0 0 30px #faf9f7 inset;
      box-shadow: 0 0 0 30px #faf9f7 inset;
    }
  `,

  LoginButton: styled.button`
    width: 100%;
    margin-top: 1.5rem;
    padding: 0.875rem 1.25rem;
    font-size: 1rem;
    font-weight: 600;
    color: #fff;
    background: linear-gradient(180deg, #7d8b6f 0%, #6b7b5c 100%);
    border: none;
    border-radius: 12px;
    cursor: pointer;
    transition:
      opacity 0.2s,
      transform 0.05s,
      box-shadow 0.2s;
    box-shadow: 0 2px 8px rgba(125, 139, 111, 0.25);

    &:hover:not(:disabled) {
      opacity: 0.92;
      box-shadow: 0 4px 12px rgba(125, 139, 111, 0.3);
    }
    &:active:not(:disabled) {
      transform: scale(0.99);
    }
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  `,

  ErrorMessage: styled.div`
    margin-top: 1rem;
    padding: 0.75rem 1rem;
    font-size: 0.8125rem;
    color: #8b4512;
    background: #fdf6ed;
    border: 1px solid #f0e0cc;
    border-radius: 10px;
  `,
};

export default LoginStyles;
